import React from 'react';
import styles from './Help.module.css';
import { Link } from 'react-router-dom';

export default class Help extends React.Component {

    constructor(props) {
        super(props);

        this.appLink = 'https://apps.apple.com/us/app/snapquizai/id6740707942';

    };

    componentDidMount() {
    };
    
    iOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    };

    render() {
        return (
            <div className={styles.rootView}>
                {/* <img src={require('../../assets/animation.gif')} className={styles.background} /> */}
                <div className={styles.background} />

                <div className={styles.headerView}>
                    <div className={styles.headerIconContainer}>
                        <div className={styles.headerIconImageContainer}>
                            <img src={require('../../assets/icon.png')} className={styles.headerIconImage} />
                        </div>
                        <div className={styles.headerIconText}>SnapQuizAI</div>
                    </div>
                    <div className={styles.headerGetAppContainer}>
                        <a href={this.appLink}>
                            <div className={styles.headerGetApp}>
                                Get App
                            </div>
                        </a>
                    </div>
                </div>

                <div className={styles.content}>
                    {/* <div className={styles.logoView}>
                        <img className={styles.logoImage} src={require('../../assets/logo.png')} />
                    </div> */}

                    <div className={styles.title}>
                        Ace your exams
                    </div>

                    <div className={styles.subtitle}>
                        Make quizzes from your
                        <div className={styles.subtitleBold}>notes, and books!</div>
                        {/* in seconds! */}
                    </div>

                    <a href={this.appLink}>
                        <img src={require('../../assets/appstore.png')} className={styles.appstore} />
                    </a>

                    <div className={styles.section}>
                        <div className={styles.subtitle}>
                            Need Help?
                        </div>
                        <div className={styles.subtitle2}>
                            You can request help from the app. Here's how:
                        </div>
                        <ol className={styles.sectionInfo}>
                            <li>In the SnapQuizAI app, tap the Settings icon</li>
                            <li>Scroll down the Settings page to see the "Questions? Need Help?" section</li>
                            <li>Tap the "Talk to us" button</li>
                            <li>From there, you can send us a message, and we will reply you in the app.</li>
                        </ol>
                        <div className={styles.subtitle2}>
                            If you still need to reach us, you can
                            <div>
                                <a href='mailto:snapquizai@gmail.com' className={styles.link}>Email Us</a>
                            </div>
                        </div>
                    </div>

                    <a href={this.appLink}>
                        <img src={require('../../assets/appstore.png')} className={styles.appstore} />
                    </a>

                    {/* <div className={styles.vibeText}>vibe</div>
                    <div className={styles.gameText}>game</div> */}



                    <div className={styles.footer}>
                        {/* <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a> */}
                        <Link to="/help" className={styles.link}>Help</Link>
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>
            </div>
        );
    };
};